import { 
	ADD_NEW_PRICING,
	ADD_NEW_PRICING_ERROR,
	ADD_NEW_PRICING_SUCCESS,
	EDIT_PRICING,
	EDIT_PRICING_ERROR,
	EDIT_PRICING_SUCCESS,
	GET_BRANCHS_PRICING,
	GET_BRANCHS_PRICING_ERROR,
	GET_BRANCHS_PRICING_SUCCESS,
	GET_COMPLETION_TIMES_PRICING,
	GET_COMPLETION_TIMES_PRICING_ERROR,
	GET_COMPLETION_TIMES_PRICING_SUCCESS,
	GET_LANGUAGES_PRICING,
	GET_LANGUAGES_PRICING_ERROR,
	GET_LANGUAGES_PRICING_SUCCESS,
	GET_PRICING, 
	GET_PRICING_ERROR, 
	GET_PRICING_SUCCESS,
	GET_WORDS_PRICING,
	GET_WORDS_PRICING_ERROR,
	GET_WORDS_PRICING_SUCCESS, 
  } from 'redux/constants/Pricing';

const initState = {
	loading: false,
	pricing: [],
	message: '',
	branchs: [],
	languages: [],
	completionTimes: [],
	words: []
}

const pricing = (state = initState, action) => {
	switch (action.type) {
		case GET_PRICING:
			return {
				...state,
				loading: true
			}
		case GET_PRICING_SUCCESS:
			return {
				...state,
				loading: false,
				pricing: action.data,
			}
		case GET_PRICING_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case GET_BRANCHS_PRICING:
			return {
				...state,
				loading: true
			}
		case GET_BRANCHS_PRICING_SUCCESS:
			return {
				...state,
				loading: false,
				branchs: action.data,
			}
		case GET_BRANCHS_PRICING_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case GET_LANGUAGES_PRICING:
			return {
				...state,
				loading: true
			}
		case GET_LANGUAGES_PRICING_SUCCESS:
			return {
				...state,
				loading: false,
				languages: action.data,
			}
		case GET_LANGUAGES_PRICING_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case GET_COMPLETION_TIMES_PRICING:
			return {
				...state,
				loading: true
			}
		case GET_COMPLETION_TIMES_PRICING_SUCCESS:
			return {
				...state,
				loading: false,
				completionTimes: action.data,
			}
		case GET_COMPLETION_TIMES_PRICING_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case GET_WORDS_PRICING:
			return {
				...state,
				loading: true
			}
		case GET_WORDS_PRICING_SUCCESS:
			return {
				...state,
				loading: false,
				words: action.data,
			}
		case GET_WORDS_PRICING_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case EDIT_PRICING:
			return {
				...state,
				loading: true,
			}
		case EDIT_PRICING_SUCCESS:
			return {
				...state,
				loading: false,
			}
		case EDIT_PRICING_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		case ADD_NEW_PRICING:
			return {
				...state,
				loading: true,
			}
		case ADD_NEW_PRICING_SUCCESS:
			return {
				...state,
				loading: false,
			}
		case ADD_NEW_PRICING_ERROR: 
			return {
				...state,
				loading: false,
				message: action.message,
			}
		default:
			return state;
	}
}

export default pricing